import { ArrowLeftIcon } from "lucide-react";
import { Link, useParams } from "react-router-dom";

import { ErrorMessage } from "@/app/components/error-message";
import { LoadingScreen } from "@/components/loading-screen";
import { Button } from "@/components/ui/button";
import { useGetAnnouncement } from "@/features/announcements/api/get-announcement";
import { UpdateAnnouncementForm } from "@/features/announcements/components/update-announcement.form";
import { OnboardingHeader } from "@/features/registration/components/onboarding-header";

export function ViewAnnouncementPage() {
  const { id } = useParams();
  const { data, isLoading, isSuccess, isError, error } = useGetAnnouncement({
    id: id ?? "",
  });

  if (isLoading)
    return (
      <div>
        <Button variant="link" asChild>
          <Link to="/admin/announcements">
            <ArrowLeftIcon className="mr-2 h-4 w-4" /> Back to announcements
          </Link>
        </Button>
        <OnboardingHeader title="Announcement Details" className="mb-6" />
        <LoadingScreen />
      </div>
    );

  if (isError || !isSuccess)
    return (
      <div>
        <Button variant="link" asChild>
          <Link to="/admin/announcements">
            <ArrowLeftIcon className="mr-2 h-4 w-4" /> Back to announcements
          </Link>
        </Button>
        <OnboardingHeader title="Announcement Details" className="mb-6" />
        <ErrorMessage error={error} />
      </div>
    );

  return (
    <div>
      <Button variant="link" asChild>
        <Link to="/admin/announcements">
          <ArrowLeftIcon className="mr-2 h-4 w-4" /> Back to announcements
        </Link>
      </Button>
      <OnboardingHeader title="Announcement Details" className="mb-6" />

      <div className="space-y-6">
        <UpdateAnnouncementForm initialData={data} />
      </div>
    </div>
  );
}
